import React from "react";
import { useNavigate } from "react-router-dom";
import { DocumentCardProps } from "./DocumentCard.types";
import { CardContainer, DocumentTitle, Icon, IconsContainer, IconsWrapper } from "./DocumentCard.styles";
import StatusBadge from "../StatusBadge/StatusBadge";
import practicesIcon from "../../assets/icons/practicesIcon.svg";
import modulesIcon from "../../assets/icons/modulesIcon.svg";
import testsIcon from "../../assets/icons/testsIcon.svg";

const DocumentCard: React.FC<DocumentCardProps> = ({
  title,
  isSubscribed,
  onClick,
}) => {
  return (
    <CardContainer onClick={onClick}>
      <IconsWrapper>
        <StatusBadge
          text={isSubscribed ? "Подписан" : "Не подписан"}
          variant={isSubscribed ? "green" : "red"}
        />
      </IconsWrapper>
      <DocumentTitle>{title}</DocumentTitle>
    </CardContainer>
  );
};

export default DocumentCard;
